import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AdminShell from "../Components/admin-shell/AdminShell";
import { useAuth } from "../utils/auth";
import { canAccessPanel } from "../utils/roles";
import { useDashboardSummaries } from "../navigation/useDashboardSummaries";
import DashboardOverview from "./DashboardOverview";

const AdminDashboard = () => {
  const navigate = useNavigate();
  const { authState } = useAuth();
  const summaries = useDashboardSummaries(authState.role, authState.permissions);

  useEffect(() => {
    if (!canAccessPanel(authState.role)) navigate("/login");
  }, [authState, navigate]);

  return (
    <AdminShell badges={summaries.badges}>
      <DashboardOverview role={authState.role} summaries={summaries} />
    </AdminShell>
  );
};

export default AdminDashboard;
